module.exports = __webpack_public_path__ + "img/user-default-bg.eab655ea.jpg";